export class LegacyErrorSearchRequest {
    unitSnd: string;
    crStampFrom: string;
    crStampTo: string;
    recTp: string;
    msgId: string;
}